<template>
  <div class="page-panel">
    <el-tabs>
      <el-tab-pane label="图片裁剪">
        <avartar></avartar>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import avartar from './testAvatar';
export default {
  data() {
    return {};
  },
  components: {
    avartar
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/adminPage/test/index.vue